/* Lumir · ajustes de marca. Los combos (Lleva 2 / Lleva 3) son solo para 100 ml: con 50 ml se ocultan. */
(() => {
  const es50 = () =>
    [...document.querySelectorAll('variant-selects input[type="radio"]:checked, variant-selects select')]
      .some(el => /^50\s*ML$/i.test((el.value || '').trim()));

  const aplicar = () => {
    const breaks = document.querySelector('quantity-breaks');
    if (!breaks) return;
    const solo1 = es50();
    breaks.querySelectorAll('label.quantity-break[data-quantity]').forEach(label => {
      if (Number(label.dataset.quantity) > 1) label.style.display = solo1 ? 'none' : '';
    });
    const marcado = breaks.querySelector('input[name="quantity"]:checked');
    if (solo1 && marcado && Number(marcado.value) > 1) breaks.querySelector('label.quantity-break[data-quantity="1"]')?.click();
  };

  // El tema vuelve a pintar el bloque al cambiar de variante: se aplica de nuevo un instante después.
  document.addEventListener('change', () => { setTimeout(aplicar, 50); setTimeout(aplicar, 600); });
  document.addEventListener('DOMContentLoaded', aplicar);
  aplicar();
})();
